import { MDBBadge, MDBBtn, MDBChip, MDBIcon, MDBInputGroup, MDBModalFooter } from "mdb-react-ui-kit";
import { forwardRef, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { customSearchNumbers, useAutoFocusSearchAfterLoads } from "../../../components/CustomSearchUtil/CustomSearch";
import { parsePhoneNumberFromString } from 'libphonenumber-js';




export const AddRemoveNumbers = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    const [selectedNumbers, setSelectedNumbers] = useState([]);
    const [addNumbers, setAddNumbers] = useState([]);
    const [removeNumbers, setRemoveNumbers] = useState([]);
    const [sourceNumber, setSourceNumber] = useState([]);
    const [updatesourcedel, setUpdateSourceDel] = useState(false);
    const [searchSourceQuery, setSearchSourceQuery] = useState('');
    const [searchDetinationQuery, setSearchDetinationQuery] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
    useAutoFocusSearchAfterLoads(dataLoaded, setDataLoaded, searchRef, true)
    
    const navigate = useNavigate();

    const handleAdd = (number) => {
        const addList = addNumbers.includes(number) ? addNumbers.filter(num => num !== number) : [...addNumbers, number];
        const removeNum = (removeNumbers.includes(number)) ? removeNumbers.filter(removenum => removenum !== number) : removeNumbers;
        setRemoveNumbers(removeNum);
        setAddNumbers(addList);
        if (addList.length > 0) {
            setErrorMessage('');
        }
    };

    useEffect(() => {
        if (props.sourceNumber && props.sourceNumber.length > 0 && !updatesourcedel) {
            setSelectedNumbers(props.selectedNum);
            const updatedSourceNumber = props.sourceNumber.filter(num => !props.selectedNum.includes(num));
            setSourceNumber(updatedSourceNumber);
            setUpdateSourceDel(true);
        }
        if(!dataLoaded){
            setDataLoaded(true)
        }
    }, [props, updatesourcedel]);

    const handleDelete = (number) => {
        const unformatNum = unFormatNumber(number);
        const updateAddList = addNumbers.includes(unformatNum) ? addNumbers.filter(num => unformatNum !== num) : addNumbers;
        setAddNumbers(updateAddList);
    }

    async function AddNumbers(e) {
        e.preventDefault();
        e.stopPropagation();
        if (addNumbers.length === 0) {
            setErrorMessage("Please add at least one DID.");
            return;
        }
        setErrorMessage(""); // clear previous error if any    
        props.setUpdateNumbersExecuted(true);
        props.setUpdatePHNum(addNumbers);
        props.onClose();
    }
    function setSelectAll(e) {
        e.preventDefault();
        e.stopPropagation();
        const filteredNumbers = customSearchNumbers(sourceNumber, searchSourceQuery);
        if (filteredNumbers.length === 0) {
            return;}
        const updateNumbers = addNumbers.concat(filteredNumbers.filter(num => !(addNumbers.includes(num))));
        setAddNumbers(updateNumbers);
    }



    return (
        <div>
            <div>
           {/* // Show destination search only if user has selected or added at least one number */}
                 {(selectedNumbers?.length>0 || addNumbers?.length>0) && (
                <div className="position-relative mb-3">
                    <div className="form-outline">
                        <input className='form-control' type='text' placeholder='Search'
                            value={searchDetinationQuery}
                            onChange={(e) => { e.preventDefault(); e.stopPropagation(); setSearchDetinationQuery(e.target.value) }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </div>
                    <MDBIcon
                        fas
                        icon="search"
                        className="custom-search_icon"
                    />
                </div>
                          )}

                {/* <MDBInputGroup className='mb-3' textAfter={<MDBIcon fas icon='search' />}>
                    <input className='form-control' type='text' placeholder='Search'
                        value={searchDetinationQuery}
                        onChange={(e) => setSearchDetinationQuery(e.target.value)}
                    />
                </MDBInputGroup> */}
                <div className="form-group row">
                    <div className="col-12">
                        <div className="form-outlines phoneNumberheight p-0">
                            <div className="chips chips-placeholder">
                            {selectedNumbers && selectedNumbers.length > 0 || addNumbers && addNumbers.length > 0 ? <>
                                {selectedNumbers && selectedNumbers.length > 0 && (
                                    customSearchNumbers(selectedNumbers, searchDetinationQuery).map((phone) => (
                                            <MDBChip
                                                key={phone} className="m-chip d-inline py-2 px-3">
                                                {formattedNumber(phone)}
                                                {/* {props.smsPhNumberDtls?.current?.length > 0 && props.checkSMSEnable(phone, props.smsPhNumberDtls.current) && <MDBBadge color="primary" title="SMS Capable" className="fw-400">
                                                    <MDBIcon far icon="comment-alt" />
                                                    </MDBBadge>} */}
                                            </MDBChip>
                                        ))
                                )}
                                {addNumbers && addNumbers.length > 0 && (
                                    customSearchNumbers(addNumbers, searchDetinationQuery).map((phone) => (
                                            <MDBChip
                                                onDelete={() => handleDelete(phone)} className="m-chip d-inline py-2 px-3"
                                                key={phone} closeIcon size="sm">
                                                {formattedNumber(phone)}
                                                {/* {props.smsPhNumberDtls?.current?.length > 0 && props.checkSMSEnable(phone, props.smsPhNumberDtls.current) && <MDBBadge color="primary" title="SMS Capable" className="fw-400">
                                                    <MDBIcon far icon="comment-alt" />
                                                    </MDBBadge>} */}
                                            </MDBChip>
                                        ))
                                )}
                                 </> : <>
                                        <p className='m-1 text-secondary'>
                                            The selected Numbers will appear in this section
                                        </p>
                                    </>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="routing-border p-0 my-4"></div>
            {errorMessage && (
                <div className="text-danger mb-3 ">
                    {errorMessage}
                </div>
            )}
 
            <div className="position-relative">
                <div className="form-outline">
                    <input className='form-control' type='text' ref={searchRef} placeholder='Search'
                        value={searchSourceQuery}
                        onChange={(e) => { e.preventDefault(); e.stopPropagation(); setSearchSourceQuery(e.target.value) }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                            }
                        }}
                    />
                </div>
                <MDBIcon
                    fas
                    icon="search"
                    className="custom-search_icon"
                />
            </div> 

            {/* <MDBInputGroup className='mb-3' textAfter={<MDBIcon fas icon='search' />}>

                <input className='form-control' type='text' placeholder='Search'
                    value={searchSourceQuery}
                    onChange={(e) => setSearchSourceQuery(e.target.value)} />

            </MDBInputGroup> */}
            <label className="selectall pt-2 text-primary cursor-pointer " onClick={(e) => setSelectAll(e)}>
                {t("selectAll")}
            </label>
            <div className="phoneNumberheight">
                <div className="routing-numbers">
                    <div className="chips chips-placeholder">
                        {sourceNumber && sourceNumber.length > 0 && (
                                    customSearchNumbers(sourceNumber, searchSourceQuery).map(number => (
                                    <div
                                        className={addNumbers.includes(number) ? "numberadd-green" : "numberadd"}
                                        onClick={() => handleAdd(number)}
                                    >
                                        {(formattedNumber(number))}
                                        {/* {props.smsPhNumberDtls?.current?.length > 0 && props.checkSMSEnable(number, props.smsPhNumberDtls.current) && <MDBBadge color="primary" title="SMS Capable" className="fw-400">
                                            <MDBIcon far icon="comment-alt" />
                                            </MDBBadge>} */}
                                    </div>
                                ))
                        )}
                    </div>
                </div>
            </div>
            {/* <MDBModalFooter>
                {addNumbers && addNumbers.length > 0 && (<>
                    <MDBBtn color="secondary" onClick={props.onClose}>
                        {t("close")}
                    </MDBBtn>
                    <MDBBtn onClick={(e) => AddNumbers(e)}>{props.sendText ?? t("add")}</MDBBtn>
                </>)}
            </MDBModalFooter> */}
            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => AddNumbers(e)}>
                    {t("add")}</button>
            </div>

        </div>
    );
});

export function formattedNumber(number) {
    if (number == null || (number + "")?.trim() == "" || number.length < 10) {
        return number;
    }

    const alphabeticRegex = /[a-zA-Z]/;
    if (alphabeticRegex.test(number)) {
        return number;
    }
    const inputNumber = (number + "").replace(/\D/g, ''); // Remove non-numeric characters


    try {

        let parsedNumber;


        if (inputNumber.length === 10) {
            // If the input number has 10 digits, assume it's in the U.S. and prepend '+1'
            parsedNumber = parsePhoneNumberFromString(`+1${inputNumber + ""}`);
        } else if (inputNumber.indexOf('+') === -1) {
            // If the input number has more than 10 digits, parse it directly
            parsedNumber = parsePhoneNumberFromString(`+${inputNumber + ""}`);
        }

        // Extract country code, national destination code (NDC), and subscriber number
        const countryCode = parsedNumber.countryCallingCode;
        const ndc = parsedNumber.nationalNumber.slice(0, 3); // Adjust this based on your requirements
        const subscriberNumber = parsedNumber.nationalNumber.slice(3);

        // Format the number as '+country code   NDC   NXX XXXX'
        const formatted = `+${countryCode} ${ndc} ${subscriberNumber.slice(0, 3)} ${subscriberNumber.slice(3)}`;

        return formatted;
    } catch (error) {
        // Handle invalid number input

    }
}

// export function formattedNumberNew(number) {
//     if (number == null || number.trim() === "") {
//         return number;
//     }

//     // Remove non-numeric characters from the input number
//     // const inputNumber = number.replace(/\D/g, '');
//     const inputNumber = number.trim();

//     try {
//         // Parse the input number
//         const parsedNumber = parsePhoneNumberFromString(inputNumber);

//         // If parsing is successful
//         if (parsedNumber) {
//             // Extract country code, national destination code (NDC), and subscriber number
//             const countryCode = parsedNumber.countryCallingCode;
//             const ndc = parsedNumber.nationalNumber.slice(0, 3); // Adjust this based on your requirements
//             const subscriberNumber = parsedNumber.nationalNumber.slice(3);

//             // Format the number as '+country code NDC XXXX XXXX'
//             const formatted = `+${countryCode} ${ndc} ${subscriberNumber.slice(0, 3)} ${subscriberNumber.slice(3)}`;
//             return formatted;
//         } else {
//             // If parsing fails, return the original number
//             return number;
//         }
//     } catch (error) {
//         // Handle any errors
//         console.error('Error formatting number:', error);
//         return number;
//     }
// }

export function unFormatNumber(number) {
    if (number && typeof number === 'string' && number.trim() !== "") {
        return number.replace(/[+ -]/g, '');
    }
    return number;

}
export function unFormatSpamNumber(number) {
    if (number && typeof number === 'string' && number.trim() !== "") {
        return number.replace(/[ -]/g, '');
    }
    return number;
}

export const validatePhoneNumber = (value) => {
    const phoneRegex = /^(\+1|1)?[2-9]\d{2}[2-9]\d{6}$/;
    if (!phoneRegex.test(value)) {
        return "Please enter a valid 10-digit US or Canadian phone number.";
    }
    return true;
};


export const validatePhoneNumberExt = (value) => {
    const phoneRegex = /^(\+1|1)?([2-9]\d{2}[2-9]\d{6}|\d{3,5})$/;
    if (!phoneRegex.test(value)) {
        return "Please enter a valid 10-digit US or Canadian phone number or valid Extension";
    }
    return true;
};

export const validateSpeeddialNum = (value) => {
    const phoneRegex = /^[0-9]$/;
    if (!phoneRegex.test(value)) {
        return "The speed dial number is invalid. It must be a single digit between 0 and 9.";
    }
    return true;
};
